module.exports = __webpack_public_path__ + "static/media/lawn-mower.0dedd813.svg";